export function recordEvent(ipmId, command, name) {
}
export function recordGenericEvent(name) {
}
